import React, { useState } from 'react';

import ProgressBar from 'components/ProgressBar';

import SwipeRight from 'images/home/swipe-right.svg';

import { clientsIcons } from 'utils/contentProvider';

import { Clients } from './SectionHomeClients.styled';

const SectionHomeClients = () => {
  const [currentClientPage, setCurrentClientPage] = useState(1);

  return (
    <Clients>
      <div className="container">
        <h2 className="big-heading white">
          Our&nbsp;
          <span className="pink">Clients.</span>
        </h2>

        <div className="d-flex clients-main">
          <div className="flex-1">
            <div className="client-block d-flex justify-content-lg-between justify-content-start">
              <div
                className="d-flex flex-wrap"
                style={{
                  transform: `translateX(-${(currentClientPage - 1) * 100}%)`,
                }}
              >
                <div className="single-client">
                  <img src={clientsIcons[0].url} alt={clientsIcons[0].title} />
                </div>
                <div className="single-client">
                  <img src={clientsIcons[1].url} alt={clientsIcons[1].title} />
                </div>
                <div className="single-client">
                  <img src={clientsIcons[2].url} alt={clientsIcons[2].title} />
                </div>
                <div className="single-client">
                  <img src={clientsIcons[3].url} alt={clientsIcons[3].title} />
                </div>
                <div className="single-client">
                  <img src={clientsIcons[4].url} alt={clientsIcons[4].title} />
                </div>
                <div className="single-client">
                  <img src={clientsIcons[5].url} alt={clientsIcons[5].title} />
                </div>
                <div className="single-client">
                  <img src={clientsIcons[6].url} alt={clientsIcons[6].title} />
                </div>
                <div className="single-client">
                  <img src={clientsIcons[7].url} alt={clientsIcons[7].title} />
                </div>
              </div>
              <div
                className="d-flex flex-wrap"
                style={{
                  transform: `translateX(-${(currentClientPage - 1) * 100}%)`,
                }}
              >
                <div className="single-client">
                  <img src={clientsIcons[8].url} alt={clientsIcons[8].title} />
                </div>
                <div className="single-client">
                  <img src={clientsIcons[9].url} alt={clientsIcons[9].title} />
                </div>
                <div className="single-client">
                  <img
                    src={clientsIcons[10].url}
                    alt={clientsIcons[10].title}
                  />
                </div>
                <div className="single-client">
                  <img
                    src={clientsIcons[11].url}
                    alt={clientsIcons[11].title}
                  />
                </div>
                <div className="single-client empty">
                  <span />
                </div>
                <div className="single-client empty">
                  <span />
                </div>
                <div className="single-client empty">
                  <span />
                </div>
                <div className="single-client empty">
                  <span />
                </div>
              </div>
            </div>
            <ProgressBar
              currentPage={currentClientPage}
              totalPages={Math.ceil(clientsIcons.length / 6)}
              setCurrentPage={setCurrentClientPage}
            />
          </div>
          <div className="flex-1" style={{ position: 'relative' }}>
            <div className="rotated-tab-txt">
              <p>
                one click at a time.
                <SwipeRight
                  style={{
                    position: 'relative',
                    transform: 'scaleX(-1) rotateZ(-90deg)',
                    margin: '0 0 0px 40px',
                    top: 24,
                  }}
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </Clients>
  );
};

export default SectionHomeClients;
